import { useDispatch, useSelector } from 'react-redux';
import Item from '../../../../components/Lists/Item';
import { SortingHeader } from '../../../../components/Sorting/SortingHeader';
import { SortingProvider } from '../../../../contexts/SortingContext';
import './OrderDetails.scss';
import { Hlght } from './VendorApproval';
import { fetchOrderDetails, selectDetails } from '../../../../redux/features/VendorModule/VendorApproval/VendorApprovalSlice';
import { useEffect } from 'react';

let mockDetails = [{
    id: 0,
    line: "1",
    partNumber: "111-222-333",
    description: "--",
    quantity: "5 EA",
    responseDate: "2025-06-15",
    leadDays: 10,
    currency: "USD",
    unitCost: "$100.00",
    discount: "-$50.00",
    duty: "$0.00",
    freightCost: "$0.00",
    taxIncluded: "+$50.00",
    subTotal: "$500.00",
    totalCost: "$500.00USD",
    estimatedShippingDate: "2025-07-15"
},
{
    id: 1,
    line: "2",
    partNumber: "111-222-333",
    description: "--",
    quantity: "5 EA",
    responseDate: "2025-06-15",
    leadDays: 10,
    currency: "USD",
    unitCost: "$100.00",
    discount: "-$50.00",
    duty: "$0.00",
    freightCost: "$0.00",
    taxIncluded: "+$50.00",
    subTotal: "$500.00",
    totalCost: "$500.00USD",
    estimatedShippingDate: "2025-07-15"
},
{
    id: 2,
    line: "3",
    partNumber: "111-222-333",
    description: "--",
    quantity: "5 EA",
    responseDate: "2025-06-15",
    leadDays: 10,
    currency: "USD",
    unitCost: "$100.00",
    discount: "-$50.00",
    duty: "$0.00",
    freightCost: "$0.00",
    taxIncluded: "+$50.00",
    subTotal: "$500.00",
    totalCost: "$500.00USD",
    estimatedShippingDate: "2025-07-15"
},
{
    id: 3,
    line: "4",
    partNumber: "111-222-333",
    description: "--",
    quantity: "5 EA",
    responseDate: "2025-06-15",
    leadDays: 10,
    currency: "USD",
    unitCost: "$100.00",
    discount: "-$50.00",
    duty: "$0.00",
    freightCost: "$0.00",
    taxIncluded: "+$50.00",
    subTotal: "$500.00",
    totalCost: "$500.00USD",
    estimatedShippingDate: "2025-07-15"
}]

const OrderDetails = ({ open, orderId }) => {

    const allDetails = useSelector(selectDetails);
    const orderDetails = allDetails[orderId];
    const dispatch = useDispatch();
    useEffect(() => {
        if (open === true) {
            dispatch(fetchOrderDetails({ orderId, companyId: localStorage.getItem("u_company_id") }));
        }
    }, [open])

    return (
        <SortingContainer>
            <div className='order-details-component'>
                <SortingHeader hideArrows />
                <div className='details-table'>

                    {orderDetails?.map(d =>
                        <Item valuePlaceholder="--" orderedProperties={["line", "partNumber", "partName", "quantity", "response_date", "lead_days", "currency", "fmt_unitPrice", "fmt_discount", "duty", "fmt_freightCost", "fmt_tax", "fmt_subtotal", "fmt_total_cost", "shipping_date"]} renderProperty={{ "leadDays": Hlght }} lightFont hideLabels key={d.id} item={d} ignoreProperties={["id"]} />
                    )}
                    {/* {mockDetails.map(d =>
                        <Item  renderProperty={{ "leadDays": Hlght }} lightFont hideLabels key={d.id} item={d} ignoreProperties={["id"]} />
                    )} */}
                </div>
            </div>
        </SortingContainer>
    )
}

const SortingContainer = ({ children }) => {
    return (
        <SortingProvider properties={{ line: "Line", partNumber: "PN", description: "Description", qty: "QTY Ordered", responseDate: "Response Date", leadDays: "Lead Days", currency: "Currency", unitCost: "Unit Cost", discount: "Discount Applied", duty: "Duty", freightCost: "Freight Cost", taxIncluded: "Tax", subtotal: "Subtotal", totalCost: "Total Cost", estimatedShippingDate: "Estimated Shipping Date" }}>
            {children}
        </SortingProvider>
    )
}

export default OrderDetails;